// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__Cfl-W","widget":"LoginPage_widget__W1Hvl"};